import { TextField, useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'

import { Layout } from 'components/layout'
import { useETEditorFormikPoolingType } from 'services/event_types'

import { SubsectionItemHeader } from '../../../../styles'
import { useHostsListData } from '../../../hooks'
import { AddHostButton } from '../../add_host_button'
import { DistributionMethod } from '../distribution_method'
import { HostsList } from '../hosts_list'

const Body = (props) => <Layout direction="column" gap="24" padding="16" {...props} />
const MembersContainer = (props) => <Layout direction="column" gap="8" {...props} />

export const UserPool = ({
  eventType,
  userPool,
  isLocked
}) => {
  const { isSubmitting } = useFormContext()
  const { isCollectiveRoundRobin } = useETEditorFormikPoolingType()

  const {
    userPoolUid,
    isHostsEmpty,
    formPath,
    hasError,
    errorMessage
  } = useHostsListData(userPool, eventType.isTeam)

  return (
    <Body data-component="user-pool-modal-body">
      <BodyText>
        {I18n.t('publisher.event_type_editor.sections.hosts.round_robin.pool_description')}
      </BodyText>
      {isCollectiveRoundRobin && (isLocked
        ? (
          <Layout direction="column" gap="4">
            <BodyText weight="bold">{I18n.t('publisher.event_type_editor.sections.hosts.round_robin.pool_label')}</BodyText>
            <BodyText>{userPool.name}</BodyText>
          </Layout>
        ) : (
          <TextField
            name={formPath}
            label={I18n.t('publisher.event_type_editor.sections.hosts.round_robin.pool_label')}
          />
        )
      )}
      <MembersContainer>
        <SubsectionItemHeader>
          <BodyText weight="bold">
            {I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.pool_members')}
          </BodyText>
          {!isLocked && (
            <AddHostButton
              isAddingRotatingHosts
              isOpenByDefault={isHostsEmpty}
              userPoolUid={userPoolUid}
              eventType={eventType}
            >
              {I18n.t('publisher.action.add')}
            </AddHostButton>
          )}
        </SubsectionItemHeader>
        {!isHostsEmpty && (
          <HostsList
            eventType={eventType}
            userPool={userPool}
            isLocked={isLocked}
          />
        )}
        {hasError && (
          <ContextualBanner
            icon={AlertWarningTriangleIcon}
            variant="danger"
          >
            {errorMessage}
          </ContextualBanner>
        )}
      </MembersContainer>
      <DistributionMethod userPool={userPool} disabled={isSubmitting} isLocked={isLocked} />
    </Body>
  )
}
